import React, { use, useEffect, useRef } from "react";
import Style from "../styles/navbar.module.scss";
import { HiMenuAlt2 } from "react-icons/hi";
import { useSelector, useDispatch } from "react-redux";
import { toggle, dropdown, setCoachLogout } from "../redux/index";
import { useNavigate } from "react-router-dom";
import Dashboard_Icon from "../assets/dashboard/Menu/Dashboard.png";
import client_list from "../assets/dashboard/All Clients List.png";
import coach_list from "../assets/dashboard/coachlist.png";
import exercise_list from "../assets/dashboard/Excercises List.png";
import create_biometric from "../assets/dashboard/Create Biometric Report.png";
import create_exercise_report from "../assets/dashboard/Create Exercise Report.png";
import create_client_account from "../assets/dashboard/Create Client Account.png";
import create_couch_account from "../assets/dashboard/Create Couch Account.png";
import Logo_Icon from "../assets/auth/logo.png";
import reset from "../assets/auth/reset.png";
import Logout_Icon from "../assets/dashboard/Menu/logout.png";
import { IoIosArrowDown } from "react-icons/io";
import Resetimg from "../assets/dashboard/profile.png";
import { coachRoutes } from "../routers/CoachRouters";
import { getCoachProfile } from "../services/coachService";
import mini_log from "../assets/dashboard/mini-logo.png";
import Delete from "../assets/exercise/delete.png";
import Close_Button from "../assets/auth/close.png";
import Suceess from "../assets/exercise/deletepopup.png";
import Swal from "sweetalert2";
import { deleteClient } from "../services/coachService";
import { getYearOptions, resetYear } from "../services";

const Navbar = () => {
  const isbutton = useSelector((state) => state.navbar.button);
  const issidebar = useSelector((state) => state.navbar.sidemenu);
  const { profile } = useSelector((state) => state.coach);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const arrowRef = useRef(null);
  const containerRef = useRef(null);
  const yearOptions = useSelector((state) => state.client.yearOptions || []);

  useEffect(() => {
    getYearOptions();
  }, []);

  const handleLogout = async () => {
    dispatch(setCoachLogout());
    navigate(coachRoutes.login);
  };
  const handleReset = async () => {
    const currentYear = new Date().getFullYear();
    const latestYearOption =
      Array.isArray(yearOptions) && yearOptions.length > 0
        ? Number(yearOptions[0])
        : null;

    if (latestYearOption && latestYearOption === currentYear) {
      // Already reset for current year – show info modal without reset button
      Swal.fire({
        html: `
          <div style="text-align: center; border-radius: 20px; position: relative;">
            <button
              id="customCloseButton"
              style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
              <img
                src=${Close_Button}
                alt="Close"
                style="width: 40px; height: 40px;"
              />
            </button>
            <img
              src=${Suceess}
              alt="Info"
              style="width: 100px; margin-bottom: 10px; margin-top: 15px;"
            />
            <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px;">Client data already transferred</h2>
            <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px;">
              The client data for <b>${latestYearOption}</b> is already transferred.
            </p>
            <button
              id="ok"
              style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
              OK
            </button>
          </div>
        `,
        showConfirmButton: false,
        width: "400px",
        customClass: {
          popup: "custom-swal-container",
        },
        didOpen: () => {
          const okButton = document.getElementById("ok");
          const closeButton = document.getElementById("customCloseButton");

          okButton.addEventListener("click", () => {
            Swal.close();
          });

          closeButton.addEventListener("click", () => {
            Swal.close();
          });
        },
      });
      return;
    }

    // Normal reset flow when current year and year option differ
    handleResetYear(currentYear);
  };
  const handleResetYear = (year) => {
    Swal.fire({
      html: `
        <div style="text-align: center; border-radius: 20px; position: relative;">
          <button
            id="customCloseButton"
            style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
            <img
              src=${Close_Button}
              alt="Close"
              style="width: 40px; height: 40px;"
            />
          </button>
          <img
            src=${Suceess}
            alt="Success"
            style="width: 100px; margin-bottom: 10px; margin-top: 15px;"
          />
          <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px;">Are you sure?</h2>
        <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px;">
  You are about to transfer all  reports to the year <b>${year}</b>. 
  This process cannot be undone.
</p>
     
          <button
            id="cancel"
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Cancel
          </button>
          <br/>
          <button
            id="delete"
            style="background: #800505; color: #f3f3f6; padding: 9px 30px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px; border: none;outline:none;">
            Reset to ${year}
          </button>
        </div>
      `,
      showConfirmButton: false,
      width: "400px",
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const deleteButton = document.getElementById("delete");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });
        deleteButton.addEventListener("click", async () => {
          Swal.close();
          
          const success = await resetYear(year);
          if (success) {
            window.location.reload();
          }
        });

        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };
  useEffect(() => {
    getCoachProfile();
  }, []);
  useEffect(() => {
    const handleClick = (event) => {
      if (
        containerRef.current &&
        containerRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        arrowRef.current &&
        !arrowRef.current.contains(event.target)
      ) {
        if (issidebar) {
          dispatch(dropdown());
        }
      }
    };

    containerRef.current?.addEventListener("click", handleClick);

    return () => {
      containerRef.current?.removeEventListener("click", handleClick);
    };
  }, [issidebar, dispatch]);

  const dashboard = () => {
    navigate(coachRoutes.dashboard);
    dispatch(toggle());
  };

  const clientList = () => {
    navigate(coachRoutes.listClient);
    dispatch(toggle());
  };
  const coachList = () => {
    navigate(coachRoutes.listCoach);
    dispatch(toggle());
  };
  const exercise = () => {
    navigate(coachRoutes.listExercise);
    dispatch(toggle());
  };
  const biometricReport = () => {
    navigate(coachRoutes.createBiometricReport);
    dispatch(toggle());
  };
  const exerciseReport = () => {
    navigate(coachRoutes.createBiometricExerciseReport);
    dispatch(toggle());
  };
  const clientmanagement = () => {
    navigate(coachRoutes.createClientAccount);
    dispatch(toggle());
  };
  const coachmanagement = () => {
    navigate(coachRoutes.createCoachAccount);
    dispatch(toggle());
  };
  const gymmanagement = () => {
    dispatch(toggle());
  };

  const handleProfile = () => {
    navigate(coachRoutes.viewProfile);
  };

  return (
    <div className={Style.navbarmaincontainer} ref={containerRef}>
      <nav className={Style.navbar}>
        <div className={Style.navbar_left}>
          <button
            className={Style.hamburger_icon}
            onClick={() => dispatch(toggle())}
          >
            {isbutton ? <HiMenuAlt2 /> : <HiMenuAlt2 />}
          </button>

          <div className={Style.logo}>
            <img src={Logo_Icon} />
          </div>
        </div>
        <div className={Style.navbar_right}>
          <div className={Style.user_info}>
            <div className={Style.user_logo}>
              <img src={mini_log} />
            </div>

            <div className={Style.user_data}>
              <div className={Style.user_name}>
                <h1>{profile?.name}</h1>
                <p style={{ marginTop: "4px" }}>{profile?.role}</p>
              </div>

              <div
                ref={arrowRef}
                onClick={() => dispatch(dropdown())}
                className={Style.userarrowdown}
              >
                <IoIosArrowDown />
              </div>

              {issidebar ? (
                <div
                  ref={dropdownRef}
                  className={Style.dropdown_password}
                  onClick={handleProfile}
                >
                  <div className={Style.dropdown_password_img}>
                    <img src={Resetimg} />
                  </div>
                  <div className={Style.dropdown_password_text}>
                    <h2>Profile</h2>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar */}
      <div className={`${Style.sidebar} ${isbutton ? Style.open : ""}`}>
        <ul className={Style.menu}>
          <li onClick={dashboard} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={Dashboard_Icon} />
                <span>Dashboard</span>
              </a>
            </div>
          </li>

          <li onClick={clientList} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={client_list} />
                <span> All Clients List</span>
              </a>
            </div>{" "}
          </li>
          <li onClick={coachList} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={coach_list} />
                <span> All Coach List</span>
              </a>
            </div>{" "}
          </li>

          {/* <li onClick={exercise} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={exercise_list} />
                <span> Exercises List</span>
              </a>
            </div>{" "}
          </li> */}

          {/* <li onClick={biometricReport} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={create_biometric} />
                <span> Create Biometric Report</span>
              </a>
            </div>{" "}
          </li> */}
          {/* <li onClick={exerciseReport} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={create_exercise_report} />
                <span> Create Exercise Report</span>
              </a>
            </div>{" "}
          </li> */}
          <li onClick={exerciseReport} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={create_exercise_report} />
                <span> Create Report</span>
              </a>
            </div>{" "}
          </li>
          <li onClick={clientmanagement} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={create_client_account} />
                <span> Create Client Account</span>
              </a>
            </div>{" "}
          </li>
          <li onClick={coachmanagement} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={create_couch_account} />
                <span> Create Coach Account</span>
              </a>
            </div>{" "}
          </li>
        </ul>

        <div className={Style.logout}>
          <button className={Style.reset_button} onClick={handleReset}>
            <span>
              <img src={reset} /> Reset
            </span>
          </button>
          <button className={Style.logout_button} onClick={handleLogout}>
            <span>
              <img src={Logout_Icon} /> Logout
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
